/**
 * Hvilken knap et prisplan-kort får i den eksterne pris-widget — samme regler
 * som den native prisside (PricingPageContent i apps/holdstyring).
 *
 * Ren funktion uden imports, så den kan testes direkte fra HS' jest (OPG-0063).
 *
 *   comingSoon → deaktiveret «Kommer snart»
 *   purchase   → klippekort/abonnement: køb (inline-modal eller handoff)
 *   contact    → «Kontakt mig»-plan: kontaktformular, ingen pris
 *   classes    → drop-in m.m.: «Se hold»
 *   none       → ingen knap («Vis Se hold-knap» er slået fra på planen)
 */
export type PlanCta = 'comingSoon' | 'purchase' | 'contact' | 'classes' | 'none'

export interface PlanCtaInput {
  membershipCategory?: string | null
  isComingSoon?: boolean
  /** Mangler feltet (ældre server), vises «Se hold» som før. */
  showClassesCta?: boolean
}

const kategori = (plan: PlanCtaInput) => plan.membershipCategory?.trim().toLowerCase() ?? ''

/** «Kontakt mig»-plan: kunden skal skrive til studiet i stedet for at købe. */
export function isContactPlan(plan: PlanCtaInput): boolean {
  return kategori(plan) === 'contact'
}

export function planCta(plan: PlanCtaInput): PlanCta {
  if (plan.isComingSoon) return 'comingSoon'
  const cat = kategori(plan)
  if (cat === 'klippekort' || cat === 'subscription') return 'purchase'
  if (cat === 'contact') return 'contact'
  // Native: «Se hold» skjules kun når toggle'en eksplicit er slået fra.
  if (plan.showClassesCta === false) return 'none'
  return 'classes'
}

/** En «Kontakt mig»-plan vises uden pris — prisen aftales i dialogen med studiet. */
export function showsPrice(plan: PlanCtaInput): boolean {
  return !isContactPlan(plan)
}
